import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  modal: {
    width: 'min(70vw, 611px) !important',
    minHeight: 'initial',
    [theme.breakpoints?.down('md')]: {
      borderRadius: 10,
      width: '85vw !important',
    },
  },
}));
